module.exports = "/_next/static/media/google.8e53c55f.png";